module.exports = __webpack_public_path__ + "static/media/2.ba6aefa6.jpg";